import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * A scroller that follows new content unless the reader has scrolled up; then `showNewPill` offers the way back.
 * `count` is how many items there are; `deps` are anything else that should re-run the follow (a panel opening).
 */
export function useFollowScroll(count: number, deps: unknown[]) {
  const ref = useRef<HTMLDivElement | null>(null);
  const followingRef = useRef(true);
  const [showNewPill, setShowNewPill] = useState(false);
  const jumpToBottom = useCallback(() => {
    const el = ref.current;
    if (el) el.scrollTop = el.scrollHeight;
    followingRef.current = true;
    setShowNewPill(false);
  }, []);
  const onScroll = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    followingRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 48;
    if (followingRef.current) setShowNewPill(false);
  }, []);
  useEffect(() => {
    if (count === 0) return;
    if (followingRef.current) jumpToBottom();
    else setShowNewPill(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, jumpToBottom, ...deps]);
  return { ref, showNewPill, jumpToBottom, onScroll };
}
